<template>
  <a-layout class="layout-3">
    <router-view />
  </a-layout>
</template>
<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
@Component({
  name: "Layout3",
})
export default class extends Vue {}
</script>
<style lang="less">
.layout-3,
.ant-layout {
  width: 100%;
  height: 100%;
}
</style>
